module.exports = __webpack_public_path__ + "img/site-dvd-eita-porra-fernando.04c6f137.jpg";